import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glowSm, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Switch', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      background: `${navy[700]} !important`,

      [`&${componentCls}-checked`]: {
        background: `${blue[500]} !important`,
        boxShadow: glowSm,

        [`${componentCls}-handle:before`]: {
          background: `#fff !important`,
        },
      },

      [`${componentCls}-handle:before`]: {
        background: `#94a3b8 !important`,
      },
    },
  }
})
